import { DocumentoTipo } from '@shared/services/interfaces/combos.interface';

/**
 * Tipo de documento que corresponde por defecto al tipo de persona: CI para la física
 * y RUC para la jurídica. El combo trae el código del tipo en `email`; el seeder usa
 * CI/RUC y el cargador legacy DOC_TIP_001/002.
 */
export function documentoTipoPorDefecto(tipos: DocumentoTipo[], personaTipo: string): number | null {
  const codigos = personaTipo === 'J' ? ['RUC', 'DOC_TIP_002'] : ['CI', 'DOC_TIP_001'];
  return tipos.find(tipo => codigos.includes(tipo.email))?.id ?? null;
}
